import { getBoolVariation } from './featbit';
import { app } from '@ekuaibao/whispered';
var VERSION = '1.0.1';
export var register = function () {
    if ('serviceWorker' in navigator) {
        navigator.serviceWorker
            .register("sw.js?v=" + VERSION)
            .then(function (registration) {
            if (registration.active) {
                var apiCacheEnabled_1 = getBoolVariation('web-service-worker-api');
                sendMessageToSW({ type: 'fluxlog', apiCacheEnabled: apiCacheEnabled_1 }).then(function (response) {
                    var _a;
                    if ((_a = response === null || response === void 0 ? void 0 : response.data) === null || _a === void 0 ? void 0 : _a.length) {
                        var logs = response.data;
                        var cacheCount = logs.filter(function (item) { return item.type === 'cache'; }).length;
                        var fetchCount = logs.filter(function (item) { return item.type === 'fetch'; }).length;
                        var errorLogs = logs.filter(function (item) { return item.type === 'error'; });
                        app.logger.info('[web-service-worker]:fluxlog', {
                            cacheCount: cacheCount,
                            fetchCount: fetchCount,
                            errorCount: errorLogs.length,
                            usedSize: response.size,
                            apiCacheEnabled: apiCacheEnabled_1
                        });
                        errorLogs.slice(0, 6).forEach(function (item) { return app.logger.error('[web-service-worker]:sw.js error', item.body); });
                    }
                });
            }
            app.logger.info('[web-service-worker]:register', {});
        })
            .catch(function (err) { return app.logger.error('[web-service-worker]:register', { error: err }); });
    }
    else {
        app.logger.warn('[web-service-worker]:register', { msg: 'browser not support' });
    }
};
export var unregister = function () {
    if ('serviceWorker' in navigator) {
        navigator.serviceWorker.getRegistration('/web/').then(function (registration) {
            if (registration) {
                sendMessageToSW({ type: 'cleanup' }).then(function () {
                    registration
                        .unregister()
                        .then(function (success) {
                        if (success) {
                            app.logger.info('[web-service-worker]:unregister', {});
                        }
                    })
                        .catch(function (err) { return app.logger.error('[web-service-worker]:unregister', { error: err }); });
                });
            }
        });
    }
    else {
        app.logger.warn('[web-service-worker]:unregister', { msg: 'browser not support' });
    }
};
export var start = function () {
    var envEnabled = (process.env.NODE_ENV === 'production' || process.env.NODE_ENV === 'beta') && !process.env.IS_STANDALONE;
    if (!envEnabled)
        return;
    if (getBoolVariation('web-service-worker')) {
        register();
    }
    else {
        unregister();
    }
};
function sendMessageToSW(message) {
    return new Promise(function (resolve) {
        var messageChannel = new MessageChannel();
        messageChannel.port1.onmessage = function (event) {
            resolve(event.data);
        };
        if (navigator.serviceWorker.controller) {
            navigator.serviceWorker.controller.postMessage(message, [messageChannel.port2]);
        }
        else {
            app.logger.warn('[web-service-worker]:sendMessageToSW', { msg: '找不到SW控制器' });
            resolve(null);
        }
    });
}
